import { Check } from 'lucide-react'

import { BottomSheet } from '@/components/ui/bottom-sheet'
import { Button } from '@/components/ui/button'
import { Checkbox } from '@/components/ui/checkbox'
import { getDomainLabel } from '@/lib/domain-labels'

import { getDomainColor } from './domain-colors'

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
  /** 選択肢として出すドメイン一覧 */
  domains: string[]
  /** 非表示にするドメイン。空なら全表示 */
  excluded: Set<string>
  onChange: (excluded: Set<string>) => void
}

/**
 * 「チェックが付いているドメインを表示する」方式のフィルタ。
 * 初期状態は全部チェック済みなので、Abema のチェックを外すだけで「Abema 以外」を作れる。
 */
export function DomainFilterSheet({ open, onOpenChange, domains, excluded, onChange }: Props) {
  const toggle = (domain: string) => {
    const next = new Set(excluded)
    if (next.has(domain)) next.delete(domain)
    else next.add(domain)
    onChange(next)
  }

  const selectedCount = domains.filter((d) => !excluded.has(d)).length
  const allChecked = domains.length > 0 && selectedCount === domains.length

  return (
    <BottomSheet title="ドメインで絞り込む" open={open} onOpenChange={onOpenChange} snapPoints={[0.8]}>
      <div className="flex flex-col gap-2 px-4 pb-6">
        <div className="flex items-center justify-between gap-2">
          <span className="text-xs text-muted-foreground">
            {selectedCount} / {domains.length} 件を表示
          </span>
          <Button
            variant="outline"
            size="sm"
            className="text-xs h-7"
            onClick={() => onChange(allChecked ? new Set(domains) : new Set())}
          >
            {allChecked ? 'すべて解除' : 'すべて選択'}
          </Button>
        </div>

        <ul className="flex flex-col">
          {domains.map((d) => {
            const checked = !excluded.has(d)
            return (
              <li key={d} className="flex items-center gap-3 border-b border-border/50 py-2.5">
                <Checkbox id={`domain-${d}`} checked={checked} onCheckedChange={() => toggle(d)} />
                <label
                  htmlFor={`domain-${d}`}
                  className={`flex-1 cursor-pointer text-sm ${checked ? '' : 'text-muted-foreground'}`}
                >
                  <span className={`rounded border px-1.5 py-0.5 text-xs ${getDomainColor(d)}`}>
                    {getDomainLabel(d)}
                  </span>
                </label>
              </li>
            )
          })}
        </ul>

        <Button size="sm" className="mt-2" onClick={() => onOpenChange(false)}>
          <Check className="size-4" />
          閉じる
        </Button>
      </div>
    </BottomSheet>
  )
}
